import { render, staticRenderFns } from "./FuncionarioInfo.vue?vue&type=template&id=8008bc60"
import script from "./FuncionarioInfo.vue?vue&type=script&lang=js"
export * from "./FuncionarioInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports